// Step 19 — small button that launches the existing chat
// (`AIWorkspace` at /chat/:id) seeded with a finding-scoped prompt.
//
// Reuses the ONLY chat flow that exists — createConversation() +
// ConversationView's initialUserMessage handoff (see AIWorkspace.jsx
// and ConversationView.jsx). Does NOT introduce a second chat system.

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { createConversation } from "../../api";

export default function AIAskQadaButton({ prompt, workspaceId, label }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const disabled = busy || !prompt;

  async function handleClick() {
    if (!prompt) return;
    setBusy(true);
    setError(null);
    try {
      const conv = await createConversation({ workspaceId });
      if (!conv?.id) {
        setError("Kunde inte skapa konversation.");
        setBusy(false);
        return;
      }
      navigate(`/chat/${conv.id}`, {
        state: { initialUserMessage: prompt },
      });
    } catch (e) {
      setError(e?.body?.detail || e.message || "Kunde inte starta konversation.");
      setBusy(false);
    }
  }

  return (
    <>
      <button
        type="button"
        className="qai-ask-qada-btn"
        onClick={handleClick}
        disabled={disabled}
        title={prompt || undefined}
      >
        {busy ? "…" : (label || "Fråga Qada")}
      </button>
      {error && <div className="qai-ask-qada-error">{error}</div>}
    </>
  );
}
